module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    class: _vm.getClassMobile(),
    style: (_vm.modalStyle()),
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "choose-user-modal-panel",
    style: (_vm.mainDivStyle())
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_choose_user")))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "choose-user-modal-toolbar"
  }, [_c('div', {
    staticClass: "choose-user-modal-toolbar__search-row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input choose-user-modal-toolbar__search-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search_users'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-button choose-user-modal-toolbar__search-btn",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": _vm.load
    }
  }, [(!_vm.isLoading) ? _c('span', [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')))]) : _c('span', {
    staticClass: "choose-user-modal-toolbar__loading-wrap"
  }, [_c('span', {
    staticClass: "loader choose-user-modal-toolbar__loading-spinner"
  })])])])]), _vm._v(" "), (_vm.mustSelectTrainerWhenReserveTraining) ? _c('div', {
    staticClass: "scrollmenu"
  }, [_vm._l((_vm.partners), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectPartner(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n              ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.successAdd.length > 0) ? _c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#4caf50"
    }
  }, [_vm._v(_vm._s(_vm.successAdd))])]) : _vm._e(), _vm._v(" "), (_vm.hasError.length > 0) ? _c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width choose-user-modal-table-wrap",
    style: (_vm.tableStyle())
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_username")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_rest_trainings")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_expire")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_payments")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_select")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(user.name) + " " + _vm._s(user.surname))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_username')
      }
    }, [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_rest_trainings')
      }
    }, [_vm._v(_vm._s(user.restOfTraining))]), _vm._v(" "), _c('td', {
      style: (_vm.getStyleActiveMembership(user)),
      attrs: {
        "data-title": _vm.locale.t('label_expire')
      }
    }, [_vm._v(_vm._s(_vm.formatDate(user.expireDate)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_payments')
      },
      on: {
        "click": function($event) {
          return _vm.goToPayments(user)
        }
      }
    }, [_c('div', {
      staticClass: "new-button"
    }, [_c('i', {
      staticClass: "ti-money"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_payments")) + "\n                  ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "data-title": _vm.locale.t('label_click_to_select_user')
      },
      on: {
        "click": function($event) {
          return _vm.chooseUser(user)
        }
      }
    }, [_c('div', {
      staticClass: "new-button"
    }, [_c('i', {
      staticClass: "ti-check"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_select")) + "\n                  ")])])])
  }), 0)]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "background-color": "#1b1e24"
    }
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ee90960!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ChooseUserModal.vue
// module id = 730
// module chunks = 0